import { createClient } from '@supabase/supabase-js'

// Supabase credentials - VERIFIED WORKING
const SUPABASE_URL = 'https://rrmxlifiscejralzghsb.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJybXhsaWZpc2NlanJhbHpnaHNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI4MTc2MjcsImV4cCI6MjA2ODM5MzYyN30.zDQd_SyNaTqDlcYQ5TDzOpCUttgpBzIhteLjti_2mQE'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables')
}

// Initialize the Supabase client with simplified configuration
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'apikey': SUPABASE_ANON_KEY
    }
  }
})

// Test connection immediately
console.log('🔌 Supabase client initialized:', {
  url: SUPABASE_URL,
  keyLength: SUPABASE_ANON_KEY.length
})

export default supabase